import { AddressData } from './AddressData';

export class AdressDataModel extends AddressData {
  private readonly COUNTRY = 'FRANCE';

  city: string | null;
  complement: string | null;
  postalCode: string | null;
  street: string | null;
  country: string | null;
  latitude: number | null;
  longitude: number | null;
  altitude: number | null;
  fullAddress: string | null;

  resApi: AddressData;

  constructor(res: AddressData) {
    super();
    this.city = res.properties.city;
    this.complement = null;
    this.postalCode = res.properties.postcode || null;
    this.street = res.properties.name || null;
    this.country = this.COUNTRY;
    this.latitude = res?.geometry?.coordinates[1] || null;
    this.longitude = res?.geometry?.coordinates[0] || null;
    this.altitude = null;
    this.fullAddress = res.properties.label;

    this.resApi = res;
  }
}
